import { render } from "./g-breadcrumb.vue?vue&type=template&id=250072c0&ts=true"
import script from "./g-breadcrumb.vue?vue&type=script&lang=tsx"
export * from "./g-breadcrumb.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__